/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseUser } from './DatabaseUser';
import {
    DatabaseUserFromJSON,
    DatabaseUserFromJSONTyped,
    DatabaseUserToJSON,
} from './DatabaseUser';

/**
 * 
 * @export
 * @interface DatabaseEntryComment
 */
export interface DatabaseEntryComment {
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryComment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryComment
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryComment
     */
    text: string;
    /**
     * 
     * @type {DatabaseUser}
     * @memberof DatabaseEntryComment
     */
    createdBy?: DatabaseUser;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseEntryComment
     */
    readonly created?: Date;
}

/**
 * Check if a given object implements the DatabaseEntryComment interface.
 */
export function instanceOfDatabaseEntryComment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function DatabaseEntryCommentFromJSON(json: any): DatabaseEntryComment {
    return DatabaseEntryCommentFromJSONTyped(json, false);
}

export function DatabaseEntryCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': json['text'],
        'createdBy': !exists(json, 'createdBy') ? undefined : DatabaseUserFromJSON(json['createdBy']),
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
    };
}

export function DatabaseEntryCommentToJSON(value?: DatabaseEntryComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'text': value.text,
        'createdBy': DatabaseUserToJSON(value.createdBy),
    };
}

